import { colors } from '../../../../theme/palette';
import { ChartContent } from './ChartContent';
import Highcharts, { Options } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ViewsByPayload } from '../../../../store/models';

export type ViewsByProps = {
	data: ViewsByPayload;
};

export const ViewsBy = (props: ViewsByProps) => {
	const { data } = props;

	const chartOptions: Options = {
		chart: {
			type: 'column',
			height: 230,
			zoomType: 'xy',
			panning: {
				enabled: true,
				type: 'xy',
			},
			panKey: 'shift',
		},
		title: {
			text: '',
		},
		series: [
			{
				type: 'column',
				data: [data['app'], data['history'], data['link'], data['scan'], data['share']],
			},
		],
		xAxis: {
			categories: ['App', 'History', 'Link', 'Scan', 'Share'],
			labels: {
				enabled: true,
				useHTML: true,
				formatter: function () {
					return `${this.value}`;
				},
				style: {
					color: colors.grayDark,
					fontSize: '12px',
					lineHeight: '20px',
				},
			},
		},
		yAxis: {
			title: { text: null },
			labels: {
				style: {
					fontSize: '12px',
					lineHeight: '20px',
				},
			},
		},
		credits: {
			enabled: false, //removing watermark
		},
		tooltip: {
			useHTML: true,
			backgroundColor: colors.grayDark,
			borderWidth: 0,
			borderRadius: 4,
			shadow: false,
			style: {
				padding: '8px 12px',
				color: colors.pureWhite,
				fontSize: '16px',
				fontWeight: '700',
				whiteSpace: 'nowrap',
			},
			formatter: function () {
				return `${this.y}`;
			},
		},
		legend: { enabled: false },
		plotOptions: {
			series: {
				cursor: 'pointer',
				color: colors.navyAccent,
			},
		},
	};

	return (
		<ChartContent name={'VIEWS BY'} toolTipMsg={'The number of views based on how a user accessed your Viiision.'}>
			<HighchartsReact highcharts={Highcharts} options={chartOptions} />
		</ChartContent>
	);
};
